import { compareDesc, parseISO } from 'date-fns';

import { cn } from '@shared/lib/utils';
import { Card, CardContent, CardHeader } from '@shared/ui/card';

import { RecentTestCard } from './RecentTestCard';
import type { DashboardTestHistoryEntry } from '../model/types';

interface RecentTestsCardProps {
  tests: DashboardTestHistoryEntry[];
  className?: string;
}

export const RecentTestsCard = ({ tests, className }: RecentTestsCardProps) => {
  const visibleTests = [...tests]
    .sort((left, right) => compareDesc(parseISO(left.date), parseISO(right.date)))
    .slice(0, 5);

  return (
    <Card className={cn('rounded-xl p-0', className)}>
      <CardHeader
        className="
          flex items-center justify-between gap-3 px-4 pt-3.5 pb-3 text-xs/none
          font-medium tracking-wide text-muted-foreground/70 uppercase
        "
      >
        <span>Test</span>
        <span>Results</span>
      </CardHeader>

      <CardContent className="border-t px-0">
        <ul>
          {visibleTests.map((test, index) => (
            <RecentTestCard
              key={[test.kind, test.date, String(index)].join('-')}
              {...test}
              isLast={index === visibleTests.length - 1}
            />
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
